<div
  class="flex flex-col py-1 px-2 justify-center items-center rounded-[4px] box-border"
  *ngIf="product"
  [ngClass]="{
    'bg-neutrals-200': product.businessLineName === 'POR DEFINIR',
    'bg-bgConcreto': product.businessLineName === 'CONCRETO',
    'bg-bgViguetas': product.businessLineName === 'VIGUETAS',
    'bg-bgBloques': product.businessLineName === 'BLOQUES',
    'bg-bgEmbolsado': product.businessLineName === 'EMBOLSADO',
  }"
>
  <p
    class="text-[8px] leading-[10px] font-semibold"
    [ngClass]="{
      'text-neutrals-700': product.businessLineName === 'POR DEFINIR',
      'text-textConcreto': product.businessLineName === 'CONCRETO',
      'text-textViguetas': product.businessLineName === 'VIGUETAS',
      'text-textBloques': product.businessLineName === 'BLOQUES',
      'text-textEmbolsado': product.businessLineName === 'EMBOLSADO',
    }"
  >
    {{ capitalizeText(product.businessLineName) }}
  </p>
</div>
